import { render, staticRenderFns } from "./baseProduct.vue?vue&type=template&id=2d6f9645"
import script from "./baseProduct.vue?vue&type=script&lang=js"
export * from "./baseProduct.vue?vue&type=script&lang=js"
import style0 from "./baseProduct.vue?vue&type=style&index=0&id=2d6f9645&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports